import { getNextApiRoute } from '@libs/common-next';
import { apiFetch } from '@libs/core';
import type { AddToOrderRecurringResponse } from '@libs/order-groove';

import type { PostOrdergrooveAddSubscription } from '../model';

export type AddSubscriptionResponse = AddToOrderRecurringResponse;

export async function addAutoshipSubscription(body: PostOrdergrooveAddSubscription): Promise<AddSubscriptionResponse> {
    const url = getNextApiRoute('ordergroove');
    const response = await apiFetch<AddSubscriptionResponse>(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
    });

    if (response instanceof Error) {
        throw new Error(response.message);
    }

    // apiFetch returns Response for non-2xx status codes
    if (response instanceof Response) {
        throw new Error('Failed to add autoship subscription. non-2xx status code.');
    }

    return response;
}
